import React from 'react';
import * as Mapbox from "react-map-gl/mapbox";
import {LayerSpecification, LineLayerSpecification, SymbolLayerSpecification} from "mapbox-gl";
import {MapLayer} from "../../../types/MapLayers";

// Types ----

type TrailLayerProps = {
  source?: string
  enabledLayers: MapLayer[]
}

// Component ----

function TrailLayer({source = '', enabledLayers}: TrailLayerProps) {

  // Filters
  const trailRouteFilter = ["==", "type", "trail-route"];
  const trailWaypointFilter = ["==", "type", "trail-waypoint"];
  const trailFilter = ["==", "type", "trail"];

  // Layout Properties
  const layout: LayerSpecification['layout'] = { visibility: enabledLayers.includes(MapLayer.TRAIL) ? "visible" : "none" };

  return (
    <>
      {/* Route */}
      <Mapbox.Layer
        type="line"
        id="ngage-trail-route-inner"
        source={source}
        filter={trailRouteFilter}
        layout={{...trailRouteLayout, ...layout}}
        paint={trailRouteInnerPaint}
      />
      <Mapbox.Layer
        type="line"
        id="ngage-trail-route-outer"
        source={source}
        filter={trailRouteFilter}
        layout={{...trailRouteLayout, ...layout}}
        paint={trailRouteOuterPaint}
      />

      {/* Waypoint */}
      <Mapbox.Layer
        type="symbol"
        id="ngage-trail-waypoint"
        source={source}
        filter={trailWaypointFilter}
        layout={{...trailWaypointLayout, ...layout}}
        paint={trailWaypointPaint}
      />

      {/* Trail */}
      <Mapbox.Layer
        type="symbol"
        id="ngage-trail"
        source={source}
        filter={trailFilter}
        layout={{...trailLayout, ...layout}}
        paint={trailPaint}
      />
    </>
  );
}

// Styles ----

const trailRouteLayout: LineLayerSpecification['layout'] = {
  "line-join": "round",
  "line-cap": "round",
}

const trailRouteInnerPaint: LineLayerSpecification['paint'] = {
  "line-color": "#0073ff",
  "line-width": 5,
}

const trailRouteOuterPaint: LineLayerSpecification['paint'] = {
  "line-color": "#0050b1",
  "line-width": 9,
}

const trailWaypointLayout: SymbolLayerSpecification['layout'] = {
  "icon-image": "ngage-pin-waypoint",
  "icon-size": 0.6,
  "icon-anchor": "bottom",
  "icon-keep-upright": true,
  "icon-allow-overlap": true,
  "text-field": ["get", "name"],
  "text-anchor": "top",
}

const trailWaypointPaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 2,
  "text-halo-color": "#FFFFFF",
}

const trailLayout: SymbolLayerSpecification['layout'] = {
  "icon-image": "ngage-pin-trail",
  "icon-size": 0.6,
  "icon-anchor": "bottom",
  "icon-keep-upright": true,
  "icon-allow-overlap": true,
  "text-field": ["get", "name"],
  "text-anchor": "top",
}

const trailPaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 2,
  "text-halo-color": "#FFFFFF",
}

export default TrailLayer;